<template>
    <div class="dynamic-fields">
        <div class="row" v-for="element in form" v-if="element['delete'] !== true">
            <div class="col-md-5">
                <div>{{ t_name }}</div>
                <div class="form-group">
                    <input aria-label="name" type="text" :name="'dynamic_fields.field_'+element['id']+'.name'" :title="t_name"
                           class="form-control" v-model="element['name']">
                </div>
            </div>
            <div class="col-md-3">
                <div>{{ t_type }}</div>
                <div class="form-group">
                    <select aria-label="type" class="form-control" :name="'dynamic_fields.field_'+element['id']+'.type'" :title="t_type"
                            v-model="element['type']">
                        <option v-for="(code, type) in types" :value="type">
                            {{ code }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="col-md-1">
                <label aria-label="delete dynamic field">&nbsp;</label>
                <div class="form-group" style="width: 34px; margin-bottom: 0;">
                    <v-btn type="button" class="btn btn-secondary" style="height: 34px; width: 34px; padding: 0 6px;" @click.stop.prevent="removeField(element['id'])" aria-label="delete dynamic field button">
                        <i class="fa-regular fa-xmark"></i>
                    </v-btn>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <v-btn type="button" class="btn btn-secondary m-b-sm" @click.stop.prevent="addField">
                    <i class="fa-regular fa-plus fa-lg m-r-xs"></i>
                    {{ t_add }}
                </v-btn>
            </div>
        </div>
        <input aria-label="XXX" type="hidden" :value="form_parsed" name="dynamic_fields">
    </div>
</template>

<script>
    export default {
        data: function () {
            return {
                t_name: Lang.langGet("Name"),
                t_type: Lang.langChoice("Type|Types", 1),
                t_add: Lang.langGet("Add Inventory Field"),
                form: {},
                types: Laravel.dynamic_field_types,
                new_fields: 0
            }
        },
        computed: {
            form_parsed: function() {
                return JSON.stringify(this.form);
            }
        },
        methods: {
            removeField: function (id) {
                this.form['field_' + id].delete = true;
            },
            addField: function () {
                let id = 'a' + this.new_fields;
                let field = {
                    delete: false,
                    id: id,
                    name: '',
                    type: 'text255'
                };

                let form = this.form;
                form['field_' + id] = field;

                this.form = _.extend({}, this.form, form);
                this.new_fields++;
            },
            reset: function () {
                _.extend(this.$data, this.$options.data());
            }
        },
        mounted() {
            EaseEventBus.listen('buildDynamicFields', (data) => {
                this.reset();
                let form = {};

                data.fields.forEach((element) => {
                    element.delete = false;
                    form['field_' + element['id']] = element;
                });

                this.form = _.extend({}, this.form, form);
            });
        }
    }
</script>
